import React from 'react'
import * as d3 from "../d3.modified.js"
import {TemplatesLib} from '../TemplatesLib'

export default class AcademicNode extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.nodeItem.refs = {}
        this.props.nodeItem.refs.fields = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleResize: this.styleResize,
            styleFade: this.styleFade
        }
    }

    componentDidMount() {
        var node = this.props.nodeItem
        this.position = undefined
        this.props.nodeItem.isJustClickNotDrag = false

        const _step = 10

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()

                // <grided>
                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
                // </grided>

                this.props.dragStartHandler()
            })
            .on('drag', ()=>{
                node.refs.holder.classed('moving', true)
                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {

                    // <grided>
                    if (this.props.keyPressDict.grid) {
                        let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                        let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                        x = parseInt((x+_step/2)/_step)*_step
                        y = parseInt((y+_step/2)/_step)*_step

                        let dx = x-node.x+node.width*0.5
                        let dy = y-node.y+node.height*0.5
                        this.props.dragHandler(dx, dy)
                    } else {
                    // </grided>
                        this.props.dragHandler(d3.event.dx, d3.event.dy)
                    }
                }
            })
            .on('end', ()=>{
                node.refs.holder.classed('moving', false)
                let newPosition = {x:d3.event.x, y:d3.event.y}
                if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                    this.props.dragEndHandler()
                }
            })
        )

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })


        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })

        node.refs.resizer.call(d3.drag()
            .on('start', ()=>{
                node.resizeData = {
                    width: node.width,
                    height: node.height,
                    x: d3.event.x,
                    y: d3.event.y
                }
                this.props.clickHandler(node, false)
            })
            .on('drag', ()=>{
                var newWidth = (d3.event.x-node.resizeData.x) + node.resizeData.width
                if (newWidth>90 && newWidth<700) {
                    if (this.props.keyPressDict.grid) {
                        node.width = Math.floor(newWidth/_step)*_step
                    } else {
                        node.width = newWidth
                    }
                }
                var newHeight = (d3.event.y-node.resizeData.y) + node.resizeData.height
                if (newHeight>this.minHeight && newHeight<250) {
                    if (this.props.keyPressDict.grid) {
                        node.height = Math.floor(newHeight/_step)*_step
                    } else {
                        node.height = newHeight
                    }
                }
                this.styleResize()
                this.props.resizeHandler(node.width, node.height, node.id)
            })
            .on('end', ()=>{
                this.props.resizeEndHandler(node)
            })
        )
    }

    componentDidUpdate() {
        var node = this.props.nodeItem
        this.props.enqueueStyleChange({
            elem: node.refs.background,
            prop: 'fill',
            val: node.properties.color
        })
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x-node.width/2} ${node.y-node.height/2})`
        })
    }

    styleResize = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)

        _(node.refs.shadow, 'width', node.width)
        _(node.refs.shadow, 'height', node.height)
        // _(node.refs.edge, 'height', node.height)
        _(node.refs.edge, 'd', `
                      M 4,0
                      h 2
                      v ${node.height}
                      h -2
                      a 4,4 0 0 1 -4,-4
                      v ${-node.height+8}
                      a 4,4 0 0 1 4,-4
                      z`)
        _(node.refs.background, 'width', node.width)
        _(node.refs.background, 'height', node.height)

         TemplatesLib[6].fields.map(
            field => {
                if (field.hasRender &&
                        (
                            node.settings.render[field.name] ||
                            (undefined===node.settings.render[field.name] && field.defaultRender)
                        )
                    ) {
                    _(node.refs.fields[field.name], 'width', node.width-30)
                }
            }
        )

        _(node.refs.resizer, 'x', node.width-10)
        _(node.refs.resizer, 'y', node.height-10)

        // _(node.refs.title, 'width', node.width)
        // _(node.refs.authors, 'width', node.width)
        // _(node.refs.year, 'width', node.width)
        // _(node.refs.tags, 'width', node.width)
        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)
    }

    // styleHover = () => {
    //     var node = this.props.nodeItem
    //     this.props.enqueueClassChange({
    //         elem: node.refs.holder,
    //         class: 'hovered',
    //         val: true,
    //     })
    // }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.edge,
            class: 'active',
            val: true,
        })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.edge,
            class: 'active',
            val: false,
        })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        // console.log("<ACN> render")

        this.minHeight = 15

        // if (this.props.transformK < 0.5) {
        //     return (
        //         <g
        //             className="node-holder node-academic-holder"
        //             transform={`translate(${node.x-node.width/2} ${node.y-node.height/2})`}
        //             ref={c=>node.refs.holder=d3.select(c)}
        //             opacity="0"
        //         >
        //             <circle
        //                 cx={node.width*0.5}
        //                 cy={node.height*0.5}
        //                 r="20"
        //                 fill="red"
        //             />
        //         </g>
        //     )
        // }

        return (
            <g
                className="node-holder node-academic-holder"
                transform={`translate(${node.x-node.width/2} ${node.y-node.height/2})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* BACKGROUND + EDGE */}
                <rect
                    className="node-shadow"
                    width={node.width}
                    height={node.height}
                    x="2"
                    y="2"
                    rx="4"
                    ry="4"
                    ref={c=>node.refs.shadow=d3.select(c)}
                />
                <rect
                    className="node-academic-background"
                    id={`N_${node.id}_bg`}
                    width={node.width}
                    height={node.height}
                    rx="4"
                    ry="4"
                    ref={c=>node.refs.background=d3.select(c)}
                    style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                />
                {/*<rect
                    className="node-academic-edge"
                    id={`N_${node.id}_edge`}
                    ref={c=>node.refs.edge=d3.select(c)}
                    style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                    width="4"
                    height={node.height}

                />*/}
                <path d={`
                      M 4,0
                      h 2
                      v ${node.height}
                      h -2
                      a 4,4 0 0 1 -4,-4
                      v ${-node.height+8}
                      a 4,4 0 0 1 4,-4
                      z`}
                    className="node-academic-edge"
                    id={`N_${node.id}_edge`}
                    ref={c=>node.refs.edge=d3.select(c)}
                    style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                ></path>
            {/* FIELDS */}
                {
                    TemplatesLib[6].fields.map(
                        field => {
                            if (field.hasRender &&
                                    (
                                        node.settings.render[field.name] ||
                                        (undefined===node.settings.render[field.name] && field.defaultRender)
                                    )
                                ) {
                                var fieldVal = ('array'!==field.type)
                                                    ? node.properties[field.name]
                                                    : node.properties[field.name].join(', ')

                                var fieldContent = (
                                    <foreignObject key={field.name} x="15" y={-5+this.minHeight} width={node.width-20} height="30" ref={c=>node.refs.fields[field.name]=d3.select(c)}>
                                        <div xmlns="http://www.w3.org/1999/xhtml" className={`node-field-${node.settings.fontSize[field.name]} neverovatno`}>
                                            {fieldVal}
                                        </div>
                                    </foreignObject>
                                )

                                if (fieldVal !== '') {
                                    if ('large' === node.settings.fontSize[field.name]) { this.minHeight += 30 }
                                    else if ('medium' === node.settings.fontSize[field.name]) { this.minHeight += 25 }
                                    else if ('small' === node.settings.fontSize[field.name]) { this.minHeight += 15 }
                                    else { console.log('ERROR!!', field.name, node.id) }
                                }

                                // if (('array'!==field.type && node.properties[field.name]==='') ||
                                //     ('array'===field.type && node.properties[field.name].length===0)) {
                                //     return null
                                // }

                                return fieldContent
                            }

                        }
                    )
                }
            {/* RESIZE */}
                <rect
                    x={node.width-10}
                    y={node.height-10}
                    width="10"
                    height="10"
                    className="node-academic-resizer"
                    ref={c=>node.refs.resizer=d3.select(c)}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/AcademicNode.js